/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum DirectionEnum {
    TO_TOP = 'TO_TOP',
    TO_RIGHT = 'TO_RIGHT',
    TO_BOTTOM = 'TO_BOTTOM',
    TO_LEFT = 'TO_LEFT',
    TO_TOP_RIGHT = 'TO_TOP_RIGHT',
    TO_BOTTOM_RIGHT = 'TO_BOTTOM_RIGHT',
    TO_BOTTOM_LEFT = 'TO_BOTTOM_LEFT',
    TO_TOP_LEFT = 'TO_TOP_LEFT',
}